export enum ConsentStatusType {
  CREATED = "CREATED",
  REVOKED = "REVOKED",
  PAUSED = "PAUSED",
  ACTIVE = "ACTIVE",
  REJECTED = "REJECTED",
  EXPIRED = "EXPIRED",
  APPROVED = "APPROVED"
}

export enum ConsentApprovalStatusType {
  PENDING = "PENDING",
}
